import { render, staticRenderFns } from "./DishRate.vue?vue&type=template&id=2f78294c&"
import script from "./DishRate.vue?vue&type=script&lang=js&"
export * from "./DishRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports